class Badge {
  id: string;
  name: string;
  display_name: string;
  description: string;
  criteria: string;
  image: string;
  user_badge: string;
  earned_at: string;

  constructor(
    id: string,
    name: string,
    display_name: string,
    description: string,
    criteria: string,
    user_badge: string,
    earned_at: string,
  ) {
    this.id = id;
    this.name = name;
    this.display_name = display_name;
    this.description = description;
    this.criteria = criteria;
    this.image = `/assets/badges/${name}.png`;
    this.user_badge = user_badge;
    this.earned_at = earned_at;
  }

  static fromServerBadge(serverBadge: Record<string, any>): Badge {
    return new Badge(
      serverBadge.badge['id'],
      serverBadge.badge['name'],
      serverBadge.badge['display_name'],
      serverBadge.badge['description'],
      serverBadge.badge['criteria'],
      serverBadge['id'],
      serverBadge['earned_at'],
    );
  }
}

export default Badge;
